import { render, staticRenderFns } from "./NewsViewForm.vue?vue&type=template&id=6e057bb4&"
import script from "./NewsViewForm.vue?vue&type=script&lang=js&"
export * from "./NewsViewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports